import React, { Component } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';

import { stableSort, getSorting, insertIf } from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import Search from '../Common/Search/Search';

import { API } from '../../ws/constants';
import './style.css';

import './style.css';

class StoreStock extends Component {
    /* START Constructor */

    constructor(props) {
        super(props);

        this.state = {
            fetchProducts:null
            ,fetchStock:null
            ,storeInfo:null
            ,editable: (this.props.isAdmin || this.props.loginData.profile.StoreStock.permission === 1)
            ,openModal:false
            ,productOrder:'asc'
            ,productOrderBy:'Name'
            ,productPage:0
            ,productRowsPerPage:25
            ,productTableLoading:false
            ,productImagesReady:false
            ,stockOrder:'asc'
            ,stockOrderBy:'Name'
            ,stockPage:0
            ,stockRowsPerPage:25
            ,stockTableLoading:false
            ,stockImagesReady:false
            ,storeId:this.props.props.match.params.id
            ,loginLevel:this.props.loginData.AccessLevel
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount() {
        this.setState({productTableLoading:true, stockTableLoading:true});

        fetch(API + 'getstores&getbyid=' + this.state.storeId)
        .then(response => response.json())
        .then(data => this.setState({ storeInfo: data }));

        this.getProducts();
        this.getStock();
    }

    /* END React own Functions */

    /* START Handles */

    handleProductSearch = (search) => {
        this.setState({productTableLoading:true});
        fetch(API + "searchproducts&storeid="+this.state.storeId+"&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ fetchProducts: data, productTableLoading:false }));
    }

    handleStockSearch = (search) => {
        this.setState({stockTableLoading:true});
        fetch(API + "searchstock&storeid="+this.state.storeId+"&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ fetchStock: data, stockTableLoading:false }));
    }

    handleProductChangePage = (event, page) => {
        this.setState({ productPage: page });
    };

    handleProductChangeRowsPerPage = event => {
        this.setState({ productRowsPerPage: event.target.value });
    };

    handleProductRequestSort = (event, property) => {
        const productOrderBy = property;
        let productOrder = 'desc';

        if (this.state.productOrderBy === property && this.state.productOrder === 'desc') {
            productOrder = 'asc';
        }

        this.setState({ productOrder, productOrderBy });
    };

    handleStockChangePage = (event, page) => {
        this.setState({ stockPage: page });
    };

    handleStockChangeRowsPerPage = event => {
        this.setState({ stockRowsPerPage: event.target.value });
    };

    handleStockRequestSort = (event, property) => {
        const stockOrderBy = property;
        let stockOrder = 'desc';

        if (this.state.stockOrderBy === property && this.state.stockOrder === 'desc') {
            stockOrder = 'asc';
        }

        this.setState({ stockOrder, stockOrderBy });
    };

    handleStockChange = (e) => {
        const targetValue = e.target.value;
        const targetId = e.target.id;
        const productId = targetId.substring(targetId.indexOf("_") + 1);
        
        this.setState({ [e.target.id]: targetValue, stockTableLoading:true });
        fetch(API + 'savestock', {
            method: 'POST'
            ,headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
            ,body: JSON.stringify({
                storeid: this.state.storeId
                , productid: productId
                , stock: targetValue
            })
        })
        .then(response => response.json())
        .then(result => {
            this.setState({stockTableLoading:false });
        });
    }

    handleAddProduct = (e) => {
        this.setState({stockTableLoading:true});
        fetch(API + 'savestock', {
            method: 'POST'
            ,headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
            ,body: JSON.stringify({
                storeid: this.state.storeId
                , productid: e.target.id
                , stock: 1
            })
        })
        .then(response => response.json())
        .then(result => {
            this.setState({ stockTableLoading:false });
            
            this.getProducts();
            this.getStock();
        });
    }

    handleRemoveProduct = (e) => {
        const targetId = e.target.id;
        const productId = targetId.substring(targetId.indexOf("_") + 1);

        if(window.confirm("Tem a certeza que quer eliminar este produto do inventário?")){
            this.setState({stockTableLoading:true});
            fetch(API + "deletestock&storeid="+this.state.storeId+"&productid="+productId)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, stockTableLoading:false });
                    
                this.getProducts();
                this.getStock();
            });
        }
    }

    /* END Handles */

    /* START Component Functions */

    getProducts = () => {
        const { storeId } = this.state;

        fetch(API + "getproducts&storeidfilter=" + storeId)
        .then(response => response.json())
        .then(data => {
            this.setState({ fetchProducts: data, productTableLoading:false }, () => this.getProductImages(true));
            
        });
    }

    getStock = () => {
        const { storeId } = this.state;

        fetch(API + "getstock&storeid=" + storeId)
        .then(response => response.json())
        .then(data => {
            this.setState({ fetchStock: data, stockTableLoading:false }, () => this.getProductImages(false));            
        });
    }

    getProductImages(isProducts) {   
        const products = isProducts ? this.state.fetchProducts.data : this.state.fetchStock.data;
        const loading = isProducts ? "productImagesReady" : "stockImagesReady";
        const promises = [];

        this.setState({[loading]: false});
        
        for(let i=0,n=products.length;i<n;i++){ 
            promises.push(fetch(API + "getproductimage&productid=" + products[i].Id))
        }

        Promise.all(promises)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then(result => {
            for(let i=0,n=products.length;i<n;i++){         
                if(result[i].data.Image){
                    products[i].Image = result[i].data.Image;
                }
            }
            this.setState({[loading]: true});
        });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    openModal = (textObj) => {
        this.setState({ returnTitle: textObj.title, returnText: textObj.text , openModal: true });
    }

    renderProductDescription(product) {
        return (
            <div className="stockProductDescriptionHolder">
                <div className="row">
                    <div className="col-12 col-md-7">
                        {product.Image && 
                        <div className="stockPDImageHolder">
                            <img src={product.Image} alt={product.Name} />
                        </div>
                        }
                        <p><span>Peso:</span> {product.Weight} (liq: {product.NetWeight})</p>
                        <p><span>Quantidade:</span> {product.Quantity}</p>
                    </div>
                    <div className="col-12 col-md-5">
                        <p><span>Nome:</span></p>
                        <p>{product.Name}</p>
                        <p><span>Fornecedor:</span></p>
                        <p>{product.SupplierName}</p>
                        <p><span>Preço: | Custo:</span></p>
                        <p>{parseFloat(product.PriceWithVat).toFixed(2) + "€"} | {parseFloat(product.CostWithVat).toFixed(2) + "€"}</p>
                        <p><span>Descrição:</span></p>
                        <p>{product.Description}</p>
                        <p><span>Observações:</span></p>
                        <p>{product.Notes}</p>
                    </div>
                </div>
            </div>
        );
    }

    /* END Component Functions */

    /* START Renders */

    render() {
        const { isAdmin, loginData } = this.props;
        const { productOrder, productOrderBy, productRowsPerPage, productPage, stockOrder, stockOrderBy, stockRowsPerPage, stockPage, editable } = this.state;

        const store = this.state.storeInfo !== null ? this.state.storeInfo.data : {}
              , viewCost = isAdmin || loginData.profile.Products.cost
              , viewPrice = isAdmin || loginData.profile.Products.price
              , products = this.state.fetchProducts !== null ? this.state.fetchProducts.data : []
              , stock = this.state.fetchStock !== null ? this.state.fetchStock.data : []
              , loadingProductsClass = this.state.productTableLoading ? " ajaxLoading" : ""
              , loadingStockClass = this.state.stockTableLoading ? " ajaxLoading" : ""
              , productImagesReady = this.state.productImagesReady
              , stockImagesReady = this.state.stockImagesReady
              , productHeaderRows = [
                  { id: 'Name', active: true, numeric: false, label: 'Produto' },
                  ...insertIf(viewPrice, { id: 'PriceWithVat', numeric: false, label: 'Preço' }),
                  ...insertIf(viewCost, { id: 'CostWithVat', numeric: false, label: 'Custo' }),
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ]
              , stockHeaderRows = [
                  { id: 'Name', active: true, numeric: false, label: 'Produto' },
                  ...insertIf(viewPrice, { id: 'PriceWithVat', numeric: false, label: 'Preço' }),
                  ...insertIf(viewCost, { id: 'CostWithVat', numeric: false, label: 'Custo' }),
                  { id: 'Stock', numeric: true, label: 'Inventário' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        return (
            <div id="storeStockPage">
                <div>
                    <div className="pageHeader">
                        <h1><i style={{color: store.Color}} className="fa fa-cubes"></i> Gestão de Inventário <span style={{color: store.Color}}>{store.Name}</span></h1>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-5">
                            <Search searchCallback={this.handleProductSearch} label="Pesquisar produto" />
                            <Table className={"responsiveTable customTable" + loadingProductsClass}>
                                <EnhancedTableHead
                                    id="productTable"
                                    className="tableRow tableHeader"
                                    headerRows={productHeaderRows}
                                    order={productOrder}
                                    orderBy={productOrderBy}
                                    onRequestSort={this.handleProductRequestSort}
                                    rowCount={products.length}>
                                </EnhancedTableHead>
                                <TableBody>
                                    {stableSort(products, getSorting(productOrder, productOrderBy))
                                        .slice(productPage * productRowsPerPage, productPage * productRowsPerPage + productRowsPerPage)
                                        .map(product =>
                                    <TableRow key={product.Id} className="tableRow">
                                        <TableCell data-title="Produto" className="tableCell">{product.Name}</TableCell>
                                        <TableCell data-title="Preço" className="tableCell">{parseFloat(product.PriceWithVat).toFixed(2) + "€"}</TableCell>
                                        { viewCost &&
                                            <TableCell data-title="Custo" className="tableCell">{parseFloat(product.CostWithVat).toFixed(2) + "€"}</TableCell>
                                        }
                                        <TableCell data-title="Ações" className="tableCell actions">                                     
                                            {productImagesReady ?
                                                <Tooltip
                                                    title={this.renderProductDescription(product)}
                                                    enterDelay={200}>
                                                    <button className="simpleBtn" onClick={() => this.openModal({ title: product.Name, text: this.renderProductDescription(product) })}><i className="far fa-list-alt fa-2x"></i></button>
                                                </Tooltip>
                                                : <span className="ajaxLoading smallLoader noBg"><i className="far fa-list-alt fa-2x"></i></span>
                                            }
                                            { editable &&
                                                <Tooltip
                                                    title={"Adicionar " + product.Name + " ao inventário de " + store.Name}
                                                    enterDelay={200}>
                                                    <button className="simpleBtn actionButton success" onClick={this.handleAddProduct}><i id={product.Id} className="fa fa-plus"></i></button>
                                                </Tooltip>
                                            }
                                        </TableCell>                                         
                                    </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                component="div"
                                count={products.length}
                                rowsPerPage={productRowsPerPage}
                                labelRowsPerPage="Linhas por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                page={productPage}
                                backIconButtonProps={{
                                    'aria-label': 'Página anterior',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Próxima página',
                                }}
                                onChangePage={this.handleProductChangePage}
                                onChangeRowsPerPage={this.handleProductChangeRowsPerPage}
                            />
                        </div>
                        <div className="col-12 col-md-7">
                            <Search searchCallback={this.handleStockSearch} label="Pesquisar inventário" />
                            <Table className={"responsiveTable customTable" + loadingStockClass}>
                                <EnhancedTableHead
                                    className="tableRow tableHeader"
                                    headerRows={stockHeaderRows}
                                    order={stockOrder}
                                    orderBy={stockOrderBy}
                                    onRequestSort={this.handleStockRequestSort}
                                    rowCount={stock.length}>
                                </EnhancedTableHead>
                                <TableBody>
                                    {stableSort(stock, getSorting(stockOrder, stockOrderBy))
                                        .slice(stockPage * stockRowsPerPage, stockPage * stockRowsPerPage + stockRowsPerPage)
                                        .map(s =>
                                    <TableRow key={s.Id} className="tableRow">
                                        <TableCell data-title="Produto" className="tableCell">{s.Name}</TableCell>
                                        <TableCell data-title="Preço" className="tableCell">{parseFloat(s.PriceWithVat).toFixed(2) + "€"}</TableCell>
                                        { viewCost &&
                                            <TableCell data-title="Custo" className="tableCell">{parseFloat(s.CostWithVat).toFixed(2) + "€"}</TableCell>
                                        }
                                        <TableCell data-title="Inventário" className="tableCell stockHolder">  
                                            <Tooltip
                                                title={"Inventário"}
                                                enterDelay={200}>
                                                <div className="fieldHolder">
                                                    <TextField fullWidth={true}
                                                            type="number"
                                                            id={"stockNumber_" + s.Id}
                                                            value={this.state["stockNumber_" + s.Id] || s.Stock}
                                                            onChange={this.handleStockChange}
                                                            disabled={!editable}
                                                            inputProps={{ min: 0, step: "1" }}
                                                            label={s.Name}/>
                                                </div>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell data-title="Ações" className="tableCell actions">                                   
                                            {stockImagesReady ? 
                                                <Tooltip
                                                    title={this.renderProductDescription(s)}
                                                    enterDelay={200}>
                                                    <button className="simpleBtn" onClick={() => this.openModal({ title: s.Name, text: this.renderProductDescription(s) })}><i className="far fa-list-alt fa-2x"></i></button>
                                                </Tooltip> 
                                                : <span className="ajaxLoading smallLoader noBg"><i className="far fa-list-alt fa-2x"></i></span>
                                            }
                                            { editable &&
                                                <Tooltip
                                                    title={"Eliminar " + s.Name + " do inventário de " + store.Name}
                                                    enterDelay={200}> 
                                                    <button type="button" className="simpleBtn actionButton danger" onClick={this.handleRemoveProduct}><i id={"removeProduct_"+s.ProductId} className="fa fa-times"></i></button>
                                                </Tooltip>
                                            }
                                        </TableCell> 
                                    </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                component="div"
                                count={stock.length}
                                rowsPerPage={stockRowsPerPage}
                                labelRowsPerPage="Linhas por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                page={stockPage}
                                backIconButtonProps={{
                                    'aria-label': 'Página anterior',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Próxima página',
                                }}
                                onChangePage={this.handleStockChangePage}
                                onChangeRowsPerPage={this.handleStockChangeRowsPerPage}
                            />
                        </div>
                    </div>
				</div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><div>{this.state.returnText}</div></div>} />}
            </div>
        );
    }
}

export default StoreStock;
